import type { User } from '../../types';
import { hasModuleAccess, hasSubPermission } from '../../utils/modulePermissions';

// Mirror the existing server policy; capture remains explicitly opt-in.
export function canSubmitPersonalTimesheet(user: User | null) {
  return Boolean(user?.role === 'admin'
    && user.sub_module_permissions?.['timesheets.personal.submit'] === true
    && hasSubPermission(user, 'timesheets.personal.submit')
    && (Number(user.is_developer || 0) === 1 || !hasSubPermission(user, 'timesheets.personal.approve')));
}

export function canReviewPersonalTimesheets(user: User | null) {
  return Boolean(user?.role === 'admin' && hasModuleAccess(user, 'employee_hours', 'view')
    && hasSubPermission(user, 'employee_hours.view_admin_hours')
    && hasSubPermission(user, 'timesheets.personal.approve'));
}

/** Fill another admin's week (Employee Hours > Admin hours) without approval authority. */
export function canFillPersonalTimesheets(user: User | null) {
  return Boolean(user?.role === 'admin' && hasModuleAccess(user, 'employee_hours', 'view')
    && hasSubPermission(user, 'employee_hours.view_admin_hours')
    && hasSubPermission(user, 'timesheets.personal.manage_others'));
}

export function canOpenAdminHours(user: User | null) {
  return canReviewPersonalTimesheets(user) || canFillPersonalTimesheets(user);
}
